import { AnyAction } from '@reduxjs/toolkit';
import { SET_CUSTOMER } from '../action-types';
import { CreateCustomerRoutine } from '../redux-routines';
import type { ISetCustomerAction } from '../actions';
import type { ICustomerRegistrationState } from '../interfaces';

export const initialState: ICustomerRegistrationState = {
  data: {
    companyInformation: {
      contractType: '',
    },
    contactInformation: {},
  },
};

export const customerRegistrationReducer = (
  state: ICustomerRegistrationState = initialState,
  action: AnyAction,
): ICustomerRegistrationState => {
  switch (action.type) {
    case SET_CUSTOMER:
      return {
        ...state,
        data: { ...state.data, ...(action as ISetCustomerAction).payload },
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
